(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-tabs')) {
    class CollectionTabs extends HTMLElement {
      connectedCallback() {
        // Move every tab button out of the interleaved button/panel source
        // order (see blocks/_collection-tab.liquid) and into its own strip
        // so the row of tabs can scroll horizontally on narrow screens
        // instead of wrapping across multiple lines. Moving nodes (not
        // cloning) keeps the click-delegation listener below working
        // unchanged, since it's bound on `this`, not on the buttons.
        const blocksContainer = this.querySelector('.collection-tabs__blocks');
        const tabButtons = this.querySelectorAll('[data-tab]');
        if (blocksContainer && tabButtons.length > 0) {
          const strip = document.createElement('div');
          strip.className = 'collection-tabs__tab-strip';
          strip.setAttribute('role', 'tablist');
          blocksContainer.removeAttribute('role');
          blocksContainer.insertBefore(strip, tabButtons[0]);
          tabButtons.forEach((button) => strip.appendChild(button));
        }

        const activate = (targetId) => {
          this.querySelectorAll('[data-tab]').forEach((button) => {
            const isActive = button.dataset.tab === targetId;
            button.classList.toggle('is-active', isActive);
            button.classList.toggle('is-inactive', !isActive);
            button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          this.querySelectorAll('[data-panel]').forEach((panel) => {
            const isActive = panel.dataset.panel === targetId;
            panel.classList.toggle('is-active', isActive);
            panel.classList.toggle('is-inactive', !isActive);
          });

          // Cards in a panel that was hidden until now never crossed the
          // IntersectionObserver's viewport, so reveal them immediately.
          this.querySelectorAll('[data-panel].is-active .collection-tabs__grid-item').forEach((card) => {
            card.classList.add('is-visible');
          });
        };

        // The block templates don't know their own position in the list
        // (they're rendered via `content_for 'blocks'`), so the first
        // tab/panel is only marked active here, once, on load.
        const firstTab = this.querySelector('[data-tab]');
        if (firstTab) activate(firstTab.dataset.tab);

        this.addEventListener('click', (event) => {
          const tabButton = event.target.closest('[data-tab]');
          if (!tabButton || !this.contains(tabButton)) return;
          activate(tabButton.dataset.tab);
        });

        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(
            (entries, obs) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-visible');
                  obs.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
          );

          this.querySelectorAll('.collection-tabs__grid-item').forEach((card, index) => {
            card.style.transitionDelay = Math.min(index % 4, 3) * 60 + 'ms';
            observer.observe(card);
          });
        } else {
          this.querySelectorAll('.collection-tabs__grid-item').forEach((card) => card.classList.add('is-visible'));
        }
      }
    }

    customElements.define('collection-tabs', CollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
